export const BOOTSTRAP_EMAIL_ACTIONS = 'BOOTSTRAP_EMAIL_ACTIONS'
export const PLACEHOLDERS = 'PLACEHOLDERS'
export const TEMPLATE_VERSIONS = 'TEMPLATE_VERSIONS'

export const SET_TOTAL_EMAIL_ACTIONS = 'SET_TOTAL_EMAIL_ACTIONS'
export const SET_SELECTED_EMAILACTIONS = 'SET_SELECTED_EMAILACTIONS'
export const SET_SELECT_ALL_STATE = 'SET_SELECT_ALL_STATE'
export const ADD_COMMUNICATION = 'ADD_COMMUNICATION'
export const UPDATE_COMMUNICATION = 'UPDATE_COMMUNICATION'
